import type { RouteRecordRaw } from 'vue-router';

/**
 * Maintenance / CMMS web screens (M8, DECISIONS.md "ADR-090 — Maintenance / CMMS (M8, WP8.7)"). Follows the
 * parallel-work convention of `planning.ts`/`payroll.ts` — `router.ts` only spreads this array into the
 * app-shell `children`.
 */
export const maintenanceRoutes: RouteRecordRaw[] = [
  {
    path: 'maintenance/equipment',
    name: 'maintenance-equipment',
    component: () => import('../pages/maintenance/EquipmentPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/pm-plans',
    name: 'maintenance-pm-plans',
    component: () => import('../pages/maintenance/PmPlansPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/breakdowns',
    name: 'maintenance-breakdowns',
    component: () => import('../pages/maintenance/BreakdownRequestsPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/work-orders',
    name: 'maintenance-work-orders',
    component: () => import('../pages/maintenance/WorkOrdersPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/work-orders/:id',
    name: 'maintenance-work-order',
    component: () => import('../pages/maintenance/WorkOrderDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/availability',
    name: 'maintenance-availability',
    component: () => import('../pages/maintenance/AvailabilityPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
  {
    path: 'maintenance/setup',
    name: 'maintenance-setup',
    component: () => import('../pages/maintenance/MaintenanceSetupPage.vue'),
    meta: { requiresModule: 'maintenance' },
  },
];
